import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import axios from 'axios'
import { API_SETTING_URL, API_VERSION } from '@/.env'

export default class StoreService extends BaseService {
  static get entity () {
    return 'stores'
  }

  static async getOutletByStore (storeID) {
    try {
      const response = await axios.get(`${API_SETTING_URL}/${API_VERSION}/stores/${storeID}/outlets`)
      if (response.data.items) {
        const data = response.data.items
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }
}
